import { render, staticRenderFns } from "./LongList.vue?vue&type=template&id=5ee80eb6&"
import script from "./LongList.vue?vue&type=script&lang=js&"
export * from "./LongList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports